module.exports = __webpack_public_path__ + "img/top-left-bg.6f0f87c1.png";